import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languagedetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'fr', 'es'],
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        debug: true, // Force debug information in console

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        // Custom detection options
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'], // Only cache in localStorage
        },

        // Set default language to 'en' as requested if detection fails or is unsure
        // lng: 'en', // Commented out to enable language detection
    });

// Debug log for user
console.log("Detected Browser Language:", navigator.language);
console.log("i18n state:", i18n.language);

export default i18n;
